import { quantityInputWrap } from "../scripts/utils/quantityInputWrap.js";
import * as domHelpers from "../scripts/utils/domHelpers.js";

class General {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.textReplacement();
        this.removeExtraTextNodes();
        this.removeExtraElements();
        this.removeWhitespaceTextNodes();
        this.removeEmptyTextElements();
        this.wrapTableElements();
        this.buttonsWrap();
        this.markupUnstyledLists();
        this.handleCheckboxAndRadioInputs();
        this.moveNewAddressLink();
        this.removeNoScriptElements();
        this.markupFormFields();
        this.showFindMyAddressButton();
        this.hideEnterMyAddressManuallyLink();
        this.toggleGiftAidInfo();
        this.modifySpektrixQuantityInput();
        this.wrapTicketSubscriptionInputs();
        this.modifySimpleSeatingInputs();
        this.formatTexts();
        this.markupProgressNav();
    }

    textReplacement() {
        const texts = [
            {
                selector: "h1.LoginHeading",
                html: "<span>Welcome back!</span>",
            },
            {
                selector: ".More_Info",
                html: "More info",
            },
            {
                selector: "#ctl00_ContentPlaceHolder_AccountCreditButton",
                html: "Credit",
            },
            {
                selector: ".ChooseSeatsHeading h1",
                html: "Choose seats",
            },
        ];

        texts.forEach((text) => {
            const element = document.querySelector(text.selector);

            if (element) {
                element.innerHTML = text.html;
            }
        });
    }

    removeExtraTextNodes() {
        const elementSelectors = [
            ".ChooseSeats .EventDetails",
            ".Event.EventDetails",
        ];

        const elements = document.querySelectorAll(elementSelectors.join(", "));

        elements.forEach((element) => {
            Array.from(element.childNodes).forEach((node) => {
                if (node.nodeType === Node.TEXT_NODE) {
                    element.removeChild(node);
                }
            });
        });
    }

    removeEmptyTextElements() {
        const elementSelectors = [
            ".ChooseSeats .SeatingAreaHeading",
            ".ChooseSeats .AreaAndVenueDetails",
            ".ChooseSeats .SeatingAreaOptionalInstructions",
        ];

        const elements = document.querySelectorAll(elementSelectors.join(", "));

        elements.forEach((element) => {
            if (
                !element.textContent.trim() &&
                !Array.from(element.children).some((child) =>
                    child.textContent.trim(),
                )
            ) {
                element.remove();
            }
        });
    }

    removeExtraElements() {
        const elementSelectors = [
            "br:has(+ .SpektrixFooter), br:only-child, .Address + br, .Input_Checkbox + br",
        ];

        const elements = document.querySelectorAll(elementSelectors.join(", "));

        elements.forEach((element) => {
            element.remove();
        });
    }

    wrapTableElements() {
        const tableSelectors = [
            ".PriceListTable",
            ".SpektrixPage.EditTickets table",
        ];

        $(tableSelectors.join(", ")).wrap(
            '<div class="responsive-table"></div>',
        );
    }

    moveNewAddressLink() {
        if ($("a.NewAddress").length) {
            $(".Addresses .Container.Address").append($("a.NewAddress"));
        }
    }

    // Add classes to form field containers to identify them
    markupFormFields() {
        const formFields = [
            { selector: `input.FirstName`, classNameSuffix: `FirstName` },
            { selector: `input.LastName`, classNameSuffix: `LastName` },
            {
                selector: `[name="DateOfBirthDay"]`,
                classNameSuffix: `DateOfBirth`,
            },
        ];

        formFields.forEach((field) => {
            const elements = document.querySelectorAll(field.selector);

            elements.forEach((element) => {
                const parent = element.closest(".spx-field-container");

                if (parent) {
                    parent.classList.add(
                        `form-field--${field.classNameSuffix}`,
                    );
                }
            });
        });
    }

    showFindMyAddressButton() {
        $(document).on("click", "#FindMyAddressButton", function () {
            if ($('[autocomplete="postal-code"]').val() != "") {
                $(this).next().show();
            }
        });
    }

    hideEnterMyAddressManuallyLink() {
        $(document).on("click", "#EnterMyAddressManuallyLink", function () {
            $(this).prev().hide();
        });
    }

    toggleGiftAidInfo() {
        $(document).on(
            "click",
            ".spx-button-tertiary__checkout--gift-aid-info",
            function () {
                $(this).toggleClass("active");
            },
        );
    }

    modifySimpleSeatingInputs() {
        const elements = document.querySelectorAll(
            "#SimpleSeatingDiv .TicketType input[type=tel]",
        );

        elements.forEach((element) => {
            quantityInputWrap(element);
        });
    }

    // Where a quantity in put is already handled by the Spektrix javascript,
    // add our quantity-input class and data-attributes to style the element
    // but don't wrap it with the quantity-input custom element.
    modifySpektrixQuantityInput() {
        const elements = document.querySelectorAll(
            ".spx-field-container__checkout--donation",
        );

        if (elements.length) {
            elements.forEach((element) => {
                element.classList.add("quantity-input");

                const input = element.querySelector(".spx-input-text");
                const incrementButton = element.querySelector(
                    ".spx-intent-increment",
                );
                const decrementButton = element.querySelector(
                    ".spx-intent-decrement",
                );

                if (input) {
                    input.setAttribute("data-quantity-value", true);
                }

                if (incrementButton) {
                    incrementButton.setAttribute(
                        "data-quantity-increment",
                        true,
                    );

                    incrementButton.textContent = null;
                    incrementButton.setAttribute("aria-label", "Increase");
                }

                if (decrementButton) {
                    decrementButton.setAttribute(
                        "data-quantity-decrement",
                        true,
                    );

                    decrementButton.textContent = null;
                    decrementButton.setAttribute("aria-label", "Decrease");
                }
            });
        }
    }

    removeNoScriptElements() {
        const noScriptElements = document.querySelectorAll("noscript");

        noScriptElements.forEach((element) => {
            element.remove();
        });
    }

    wrapTicketSubscriptionInputs() {
        $(
            ".spx-subsection-container__ticket-subscription--display input[type=number]",
        ).val(0);
        $(
            ".spx-subsection-container__ticket-subscription--display input[type=number]",
        ).attr("type", "number");
        $(
            ".spx-subsection-container__ticket-subscription--display input[type=number]",
        ).attr("min", "0");
    }

    removeWhitespaceTextNodes() {
        const elements = document.querySelectorAll("*");

        elements.forEach(function (element) {
            // Check if the element's children are exclusively text nodes or it has no child nodes
            if (
                element.childNodes.length === 0 ||
                (element.childNodes.length === 1 &&
                    element.childNodes[0].nodeType === Node.TEXT_NODE)
            ) {
                // Remove whitespace-only text nodes
                if (
                    element.childNodes[0] &&
                    !element.childNodes[0].nodeValue.trim()
                ) {
                    element.childNodes[0].nodeValue = "";
                }
            }
        });
    }

    markupUnstyledLists() {
        const unstyledListsSelectors = [
            "#ctl00_ContentPlaceHolder_ItemsUpdate .Breakdown",
            ".AddCard .AddressList",
        ];

        const unstyledLists = document.querySelectorAll(
            unstyledListsSelectors.join(", "),
        );

        unstyledLists.forEach((list) => {
            list.setAttribute("role", "list");
        });
    }

    handleCheckboxAndRadioInputs() {
        const radioCheckboxInputSelectors = [
            `.spx-input-radio`,
            `[type="radio"]`,
            `.spx-input-checkbox`,
            `[type="checkbox"]`,
        ];

        const radioCheckboxInputs = document.querySelectorAll(
            radioCheckboxInputSelectors.join(", "),
        );

        radioCheckboxInputs.forEach((input) => {
            const validParentClasses = [
                ".spx-field-container",
                ".AddressOption",
                ".Input_Checkbox",
                ".Checkbox",
                ".BestAvailableSeatingAreaSelectAll",
                ".BestAvailableSeatingAreaRow td",
                ".AddressList li",
            ];

            if (input.parentNode.matches(".form-field--checkbox-radio")) {
                return;
            }

            if (input.parentNode.matches(validParentClasses.join(", "))) {
                input.parentNode.classList.add("form-field--checkbox-radio");
            }
        });
    }

    buttonsWrap() {
        const buttonSelectors = [
            `[id*="ContinueToBasketButton"]`,
            `.AddCard [value="Continue"]`,
            `form .NextButton`,
            `.spx-intent-continue`,
        ];

        const ignoreSelectors = [
            `.spx-button-primary__checkout--donations`,
            `.spx-button-secondary__checkout--donations`,
        ];

        buttonSelectors.forEach((selector) => {
            const buttons = document.querySelectorAll(selector);

            buttons.forEach((button) => {
                // If the button matches any of the ignore selectors, return
                if (button.matches(ignoreSelectors.join(","))) {
                    return;
                }

                if (button.classList.contains(selector)) {
                    return;
                }

                if (!button.parentNode.classList.contains("Buttons")) {
                    domHelpers.wrapEach(button, {
                        element: "div",
                        className: "Buttons",
                    });
                }
            });
        });
    }

    /** remove extra characters from texts */
    formatTexts() {
        // Remove extra characters from texts (removes all text nodes between elements)
        $(".ChooseSeats .EventDetails, .ChooseSeats .AreaAndVenueDetails")
            .contents()
            .filter(function () {
                return this.nodeType == 3;
            })
            .remove();

        // Remove unwanted `!` characters from texts
        var regex = /(!)/gm;
        var subst = "";
        $("b.PriorityBooking").text(function () {
            return $(this).text().replace(regex, subst);
        });
    }

    markupProgressNav() {
        const progressNav = document.querySelector(".Progress");

        if (progressNav) {
            // Move the progress nav to the top of the page
            domHelpers.insertElementBefore(
                document.querySelector(".SpektrixPage"),
                progressNav,
            );

            // Create a DOM parser to parse the original markup string into a document
            const parser = new DOMParser();
            const doc = parser.parseFromString(
                progressNav.outerHTML,
                "text/html",
            );

            // Extract the list items from the original markup
            const listItems = doc.querySelectorAll("ol li");

            // Function to convert each list item
            const convertListItem = (li) => {
                const link = li.querySelector("a");
                const current = li.querySelector(".Current");
                let content = "";

                if (link) {
                    // If there is a link, capture its href and inner content
                    const href = link.getAttribute("href");
                    const innerContent = link.innerHTML;

                    // Return the template literal for the new structure with the href and content
                    return `
                        <li class="progress-nav-item ${
                            current ? "is-active" : ""
                        }">
                            <a class="progress-nav-item__wrap progress-nav-item__link" href="${href}">
                                <span class="progress-nav-item__icon"></span>
                                <span class="progress-nav-item__text">
                                    ${innerContent}
                                </span>
                            </a>
                        </li>`;
                } else {
                    // If there is no link, capture the inner content of the list item
                    const innerContent = li.innerHTML;

                    // Return the template literal for a non-link list item
                    return `
                        <li class="progress-nav-item ${
                            current ? "is-active" : ""
                        }">
                            <span class="progress-nav-item__wrap">
                                <span class="progress-nav-item__icon"></span>
                                <span class="progress-nav-item__text">
                                    ${innerContent}
                                </span>
                            </span>
                        </li>`;
                }
            };

            // Map over all list items and convert them to the new format
            const newListItems = Array.from(listItems)
                .map(convertListItem)
                .join("");

            // Template literal for the new markup structure
            const newMarkup = `
                <nav role="navigation" class="progress-nav">
                    <div class="progress-nav__inner">
                        <ol class="progress-nav__items flex-list" role="list">
                            ${newListItems}
                        </ol>
                    </div>
                </nav>`;

            // Replace the original markup with the new markup
            progressNav.outerHTML = newMarkup;
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new General();
});
